var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmail = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7261_176830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.75H1.5C1.10218 0.75 0.720644 0.908035 0.43934 1.18934C0.158035 1.47064 0 1.85218 0 2.25L0 2.55L6 5.925L12 2.625V2.25C12 1.85218 11.842 1.47064 11.5607 1.18934C11.2794 0.908035 10.8978 0.75 10.5 0.75Z",
    fill: "#8094A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.4249L0 4.2749V9.7499C0 10.1477 0.158035 10.5293 0.43934 10.8106C0.720644 11.0919 1.10218 11.2499 1.5 11.2499H10.5C10.8978 11.2499 11.2794 11.0919 11.5607 10.8106C11.842 10.5293 12 10.1477 12 9.7499V4.2749L6.375 7.4249C6.2568 7.47683 6.1291 7.50365 6 7.50365C5.8709 7.50365 5.7432 7.47683 5.625 7.4249Z",
    fill: "#8094A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7261_176830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.4aa73d4c.svg";
export { ForwardRef as ReactComponent };